import { AppState } from '@auth0/auth0-react';

const getNonce = () =>
  btoa(
    String.fromCharCode(
      ...Array.from(crypto.getRandomValues(new Uint8Array(16)))
    )
  );

export type Auth0AppState = AppState & {
  redirectNonce?: string;
};

export const storePath = (state?: AppState): Auth0AppState => {
  const nonce = getNonce();

  window.sessionStorage.setItem(nonce, window.location.pathname);
  return {
    ...state,
    redirectNonce: nonce,
  };
};

export const restorePath = (state: Auth0AppState) => {
  const nonce = state.redirectNonce;
  if (nonce) {
    const path = window.sessionStorage.getItem(nonce);
    window.sessionStorage.removeItem(nonce);
    return path;
  }

  return undefined;
};
